import { Injectable } from '@angular/core';

import { Api } from './api';

@Injectable({
    providedIn: 'root'
})

export class SpatialApi {

    constructor(private readonly api: Api) { }

    spatialProperties = `
        isIntersect,
        primaryDynamicLayers,
        primaryFeatureLayers,
        joinedDynamicLayers,
        joinedFeatureLayers,
        joinedGeometries
    `;

    async spatialQuery(isIntersect: boolean, primaryDynamicLayers?: any[], primaryFeatureLayers?: any[], joinedDynamicLayers?: any[], joinedFeatureLayers?: any[], joinedGeometries?: string[], processingType?: string, srMatch = true) {
        return await this.api.http2.graphqlRequest(`
                mutation SpatialJoin($primaryDynamicLayers: [DynamicLayerSpatialGraphType], $primaryFeatureLayers: [FeatureLayerSpatialGraphType], $joinedDynamicLayers: [DynamicLayerSpatialGraphType], $joinedFeatureLayers: [FeatureLayerSpatialGraphType], $joinedGeometries: [String], $isIntersect: Boolean, $processingType: String, $srMatch: Boolean) {
                    spatialJoin(primaryDynamicLayers: $primaryDynamicLayers, primaryFeatureLayers: $primaryFeatureLayers, joinedDynamicLayers: $joinedDynamicLayers, joinedFeatureLayers: $joinedFeatureLayers, joinedGeometries: $joinedGeometries, isIntersect: $isIntersect, processingType: $processingType, srMatch: $srMatch)
                        {id guid resultCount}
                }
        `, { primaryDynamicLayers, primaryFeatureLayers, joinedDynamicLayers, joinedFeatureLayers, joinedGeometries, isIntersect, processingType, srMatch},
            'POST', 'spatialJoin');
    }

    async spatialQuery_OID(isIntersect: boolean, primaryDynamicLayers?: any[], primaryFeatureLayers?: any[], joinedDynamicLayers?: any[], joinedFeatureLayers?: any[], joinedGeometries?: any[], processingType?: string, srMatch = true) {
        return await this.api.http2.graphqlRequest(`
                mutation spatialJoin_ObjectId($primaryDynamicLayers: [DynamicLayerSpatialGraphType], $primaryFeatureLayers: [FeatureLayerSpatialGraphType], $joinedDynamicLayers: [DynamicLayerSpatialGraphType], $joinedFeatureLayers: [FeatureLayerSpatialGraphType], $joinedGeometries: [String], $isIntersect: Boolean, $processingType: String, $srMatch: Boolean) {
                    spatialJoin_ObjectId(primaryDynamicLayers: $primaryDynamicLayers, primaryFeatureLayers: $primaryFeatureLayers, joinedDynamicLayers: $joinedDynamicLayers, joinedFeatureLayers: $joinedFeatureLayers, joinedGeometries: $joinedGeometries, isIntersect: $isIntersect, processingType: $processingType, srMatch: $srMatch)
                        {id objectIds resultCount}
                }
        `, { primaryDynamicLayers, primaryFeatureLayers, joinedDynamicLayers, joinedFeatureLayers, joinedGeometries, isIntersect, processingType, srMatch},
            'POST', 'spatialJoin_ObjectId');

    }
}
